module.exports = __webpack_public_path__ + "static/media/Node.0885ad97.png";